import { FormLabel, FormControl, InputGroup, Text } from "@chakra-ui/react";
import ReactSelect from "react-select";

const FormikSearchAbleTagSelect = ({
  formik,
  label,
  name = "",
  placeholder,
  labelColor,
  labelSize,
  style,
  children,
  onSelectChange,
}) => {
  return (
    <FormControl style={style}>
      <FormLabel
        color={labelColor ? labelColor : "black"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={labelSize ? labelSize : "12px"}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <ReactSelect
          isClearable
          value={placeholder}
          placeholder={placeholder}
          onChange={onSelectChange}
          options={children?.map((child) => {
            return {
              value: child?.props?.value,
              label: child?.props?.children,
            };
          })}
          menuPortalTarget={document.body}
          styles={{
            container: (styles) => ({ ...styles, width: "100%" }),
            control: (styles) => ({
              ...styles,
              borderColor: "#E2E2E2",
              borderRadius: 4,
              paddingBlock: 5,
              height: 58,
            }),
            menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
          }}
        />
      </InputGroup>
      {formik.touched[name] && formik.errors[name] ? (
        <Text color="#800" fontSize="10px">
          {formik.errors[name]}
        </Text>
      ) : null}
    </FormControl>
  );
};

export default FormikSearchAbleTagSelect;
